import { FC, PropsWithChildren, ReactElement } from 'react'
import classNames from 'classnames'

import './Notice.scss'

export type NoticeType = 'warning' | 'info' | 'error' | 'success'

interface NoticeProps extends PropsWithChildren<unknown> {
    type?: NoticeType
    className?: string
}

export const Notice: FC<NoticeProps> = ({
    type = 'warning',
    className = '',
    children,
}): ReactElement => {
    const noticeClassName = classNames('notice', `notice--${type}`, className)

    return (
        <p className={noticeClassName}>
            {children}
        </p>
    )
}
